"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Option", {
  enumerable: true,
  get: function get() {
    return _Option["default"];
  }
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _component = _interopRequireWildcard(require("../base/component"));

var _index = _interopRequireDefault(require("../icon/index"));

var _index2 = _interopRequireDefault(require("../poptip/index"));

var _Option = _interopRequireDefault(require("./Option"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Select = /*#__PURE__*/function (_KZUIComponent) {
  _inherits(Select, _KZUIComponent);

  var _super = _createSuper(Select);

  function Select(props) {
    var _this;

    _classCallCheck(this, Select);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "wrp", void 0);

    _this.autoBind('handleSelect', 'handleBlur', 'handleLoadMore', 'handleClick');

    return _this;
  }

  _createClass(Select, [{
    key: "initStateFromProps",
    value: function initStateFromProps(props) {
      var selectedText = props.defaultText;
      var value = props.value;
      var initialExpand = props.initialExpand;
      var selected = props.options.filter(function (item) {
        return item.value === props.value;
      });

      if (selected.length > 0) {
        selectedText = selected[0].text;
        value = selected[0].value;
      }

      return {
        expand: initialExpand || false,
        value: value,
        selectedText: selectedText
      };
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var options = nextProps.options,
          value = nextProps.value;
      var selected = options.filter(function (item) {
        return item.value === value;
      });
      var newSelectedText = this.props.defaultText;

      if (selected.length > 0) {
        newSelectedText = selected[0].text;
      }

      this.setState({
        selectedText: newSelectedText,
        value: value
      });
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      var _this2 = this;

      if (this.props.disabled) {
        return;
      }

      var expand = this.state.expand;
      this.wrp.focus();
      this.setState({
        expand: !expand
      }, function () {
        if (!expand && _this2.props.onExpand) {
          _this2.props.onExpand();
        }
      });
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(e) {
      if (e.relatedTarget && this.wrp.contains(e.relatedTarget)) {
        e.preventDefault();
        return;
      }

      this.setState({
        expand: false
      });
    }
  }, {
    key: "handleSelect",
    value: function handleSelect(selected) {
      // TODO value是否需要完全受控
      this.setState({
        selectedText: selected.text,
        value: selected.value,
        expand: false
      });

      if (this.props.onChange) {
        this.props.onChange({
          name: this.props.name,
          value: selected.value,
          selectedText: selected.text,
          text: selected.text
        });
      }
    }
  }, {
    key: "handleLoadMore",
    value: function handleLoadMore() {
      var _this3 = this;

      var onLoadMore = this.props.onLoadMore;
      if (onLoadMore === null) return;
      this.wrp.focus();
      setTimeout(function () {
        _this3.setState({
          expand: true
        });
      }, 50);
      onLoadMore();
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames,
          _this4 = this;

      var clsPrefix = 'kui-select';
      var _this$props = this.props,
          className = _this$props.className,
          style = _this$props.style,
          disabled = _this$props.disabled,
          size = _this$props.size,
          popoverCls = _this$props.popoverCls,
          popoverStyle = _this$props.popoverStyle,
          maxHeight = _this$props.maxHeight;
      var expand = this.state.expand;
      var cls = (0, _classnames["default"])(clsPrefix, (_classNames = {}, _defineProperty(_classNames, "".concat(clsPrefix, "-expand"), expand), _defineProperty(_classNames, "".concat(clsPrefix, "-disabled"), disabled), _defineProperty(_classNames, "".concat(clsPrefix, "-").concat(size), !!size), _classNames), className);
      var optionsPanelCls = (0, _classnames["default"])(popoverCls, "".concat(clsPrefix, "-options-panel"));

      var finalPopoverStyle = _objectSpread({}, popoverStyle);

      if (maxHeight) {
        finalPopoverStyle = _objectSpread(_objectSpread({}, popoverStyle), {}, {
          maxHeight: "".concat(maxHeight, "px")
        });
      }

      var width = this.wrp && this.wrp.offsetWidth;
      return /*#__PURE__*/React.createElement("div", {
        ref: this.storeRef('wrp'),
        className: cls,
        style: style,
        role: "button",
        tabIndex: 0,
        onClick: this.handleClick
      }, /*#__PURE__*/React.createElement(_index2["default"], {
        isPopover: true,
        placement: "bottom-left",
        visible: expand,
        onVisibleChange: function onVisibleChange(visible) {
          return _this4.setState({
            expand: visible
          });
        },
        trigger: "click",
        tipStyle: {
          padding: 0,
          width: width,
          minWidth: 'auto'
        },
        theme: "light",
        style: {
          width: "100%",
          height: '100%'
        },
        tip: /*#__PURE__*/React.createElement("div", {
          className: optionsPanelCls,
          style: _objectSpread(_objectSpread({}, finalPopoverStyle), {}, {
            display: expand ? 'block' : 'none',
            width: width
          })
        }, /*#__PURE__*/React.createElement("div", {
          className: "".concat(clsPrefix, "-options")
        }, this.props.options.map(function (option, index) {
          return /*#__PURE__*/React.createElement(_Option["default"], {
            key: "option-".concat(index),
            value: option.value,
            selected: _this4.state.value === option.value,
            onClick: _this4.handleSelect,
            disabled: option.disabled,
            isLabel: option.isLabel,
            isSubOption: option.isSubOption
          }, option.text);
        }), this.props.options.length === 0 && /*#__PURE__*/React.createElement(_Option["default"], {
          style: {
            color: '#9b9b9b'
          }
        }, "\u6CA1\u6709\u5185\u5BB9"), this.props.hasMore ? /*#__PURE__*/React.createElement(_Option["default"], {
          style: {
            color: '#9b9b9b'
          },
          value: "",
          onClick: this.handleLoadMore
        }, "\u70B9\u51FB\u52A0\u8F7D\u66F4\u591A") : null))
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-selected"),
        tabIndex: 0,
        onBlur: this.handleBlur
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-selected-title")
      }, this.state.selectedText), /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-indicator")
      }, /*#__PURE__*/React.createElement(_index["default"], {
        type: "nav-pull-down"
      })))));
    }
  }]);

  return Select;
}(_component["default"]);

_defineProperty(Select, "defaultProps", _objectSpread(_objectSpread({}, _component.baseDefaultProps), {}, {
  defaultText: '请选择',
  value: null,
  name: '',
  disabled: false,
  options: [],
  onChange: null,
  maxHeight: null,
  hasMore: false,
  onLoadMore: null,
  onExpand: null,
  popoverCls: '',
  popoverStyle: {},
  size: '',
  initialExpand: false
}));

var _default = Select;
exports["default"] = _default;